import { LoginDialogContext, LoginDialogContextValue } from "@/providers/login-dialog";
import { useContext } from "react";

export function useLoginDialog(): LoginDialogContextValue {
	const context = useContext(LoginDialogContext);
	if (!context) {
		throw new Error("useLoginDialog must be used within LoginDialogProvider");
	}
	return context;
}
